import { render, staticRenderFns } from "./CompareSectV2.vue?vue&type=template&id=42986a98&"
import script from "./CompareSectV2.vue?vue&type=script&lang=js&"
export * from "./CompareSectV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42986a98', component.options)
    } else {
      api.reload('42986a98', component.options)
    }
    module.hot.accept("./CompareSectV2.vue?vue&type=template&id=42986a98&", function () {
      api.rerender('42986a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/CompareSectV2.vue"
export default component.exports